







































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Dialog from '../components/Dialog.vue';

@Component({
  components: {
    Dialog,
  },
})
export default class DeviceInformation extends Vue {
  private openDialog: boolean = false;

  @Getter private activeOrganisationId!: number;

  private mounted() {
    this.openDialog = true;
  }

  private closeDialog() {
    this.openDialog = false;
    this.$router.replace(`/organisation/${this.activeOrganisationId}/tasks`);
  }

  private get maxWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return '80vw';
      case 'sm':
        return '65vw';
      case 'md':
        return '40vw';
      case 'lg':
        return '35vw';
      case 'xl':
        return '35vw';
    }
  }
}
